import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

type TProps = {
  isActive: boolean;
  count: number;
  isLoading?: boolean;
}

const BadgeCounter = ({ isActive, count, isLoading }: TProps) => (
  <span
    className={cn(
      'px-1.5 py-1 text-xs leading-none rounded-full flex items-center justify-center min-w-6 min-h-6',
      isActive
        ? 'bg-purple-600 text-white'
        : 'bg-muted',
    )}>
    {isLoading ? (
      <Loader2 className="h-3 w-3 animate-spin" />
    ) : (
      count
    )}
  </span>
);

export default BadgeCounter;
